function chunkMonths(months: string[]): string[][] {
  return months.reduce<string[][]>((chunks, month, index) => {
    const chunkIndex = Math.floor(index / 4);

    return !!chunks[chunkIndex]
      ? [
          ...chunks.slice(0, chunkIndex),
          [...chunks[chunkIndex], month],
          ...chunks.slice(chunkIndex + 1),
        ]
      : [...chunks, [month]];
  }, []);
}

export { chunkMonths };
